import { Button } from '@repo/videa-components/src/index';
import classNames from 'classnames';

export const TableNavItem = ({
  children,
  dataCy,
  onClick,
  selected,
  dataTestId,
}: {
  children: React.ReactNode;
  dataCy?: string;
  dataTestId?: string;
  onClick: () => void;
  selected?: boolean;
}) => {
  return (
    <Button
      variant="outline"
      className={classNames(
        'vai-w-28 vai-h-10 hover:vai-bg-zinc-100',
        selected &&
          'vai-bg-sapphire-50 vai-text-primary hover:vai-bg-sapphire-100 hover:vai-text-primary',
      )}
      data-cy={dataCy}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
